import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import '../login.css';
import API from "../Network/API"
import { USER_LOGGED_IN } from '../Reducer/authSlice';
import toast, { Toaster } from 'react-hot-toast';
import Env from '../CustomHook/Env';

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [step, setStep] = useState(1)
  const formRef = useRef()
  const formRef1 = useRef()
  const [inputCode, setInputCode] = useState('');
  const [generatedCode, setGeneratedCode] = useState('');
  const [forgot,setForgot]=useState(false);

  // Generate a new 4-digit random code
  const generateCode = () => {
    const code = Math.floor(1000 + Math.random() * 9000).toString();
    setGeneratedCode(code);
  };

  useEffect(() => {
    generateCode();
    const loaderElement = document.querySelector(".loading-mask");
    loaderElement.removeAttribute('hidden');
    if (loaderElement && !loaderElement.hasAttribute('hidden')) {
      loaderElement.setAttribute('hidden', 'true');
    }
  }, []);

  const handleSubmitOtp = (event) => {
    event.preventDefault();
    setLoading(true);
    var data = {
      'email': email,
      'password': password,
      'otp': otp,
    }
    API.post('/v1/oauth/token', data).then(response => {
      setLoading(false);
      if (response.data.success === true) {
        localStorage.setItem(
          'auth',
          JSON.stringify({
            user: response?.data?.data?.user,
            accessToken: response?.data?.data?.token,
          })
        )
        localStorage.setItem("token", response?.data?.data?.token)
        window.location.href = '/';
        // dispatch(
        //   USER_LOGGED_IN({
        //     user: response?.data?.data?.user,
        //     accessToken: response?.data?.data?.token,
        //   })
        // )
        // window.location.href = '/';
        toast.success(response.data.message, { duration: 3000 })
      } else {

      }
    }).catch((error) => {
      setLoading(false);
      console.log(error.response.data.message)
      if (error.code == "ERR_BAD_REQUEST") {
        toast.error(error.response.data.message)
      }
    });

  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    const loginId = (email || "").trim();
    if (!loginId) {
      toast.error('Enter email or mobile number');
      setLoading(false);
      return false;
    }

    if (inputCode !== generatedCode) {
      alert('Validation code is incorrect');
      setInputCode('');
      generateCode(); // Regenerate code on failure
      setLoading(false);
      return;
    }

    var data = {
      'email': email,
      'password': password,
    }
    API.post('/v1/oauth/web_login', data).then(response => {
      setLoading(false);
      if (response?.data?.data?.is_demo == 1) {
        localStorage.setItem(
          'auth',
          JSON.stringify({
            user: response?.data?.data?.user,
            accessToken: response?.data?.data?.token,
          })
        )
        localStorage.setItem("token", response?.data?.data?.token)
        window.location.href = '/';
        return;
      }
      setStep(2)
      if (formRef.current) {
        formRef.current.reset();
      }
      toast.success(response.data.message)
    }).catch((error) => {
      setLoading(false);
    //  console.log(error.response.data.message)
      if (error.code == "ERR_BAD_REQUEST") {
        toast.error(error.response.data.message)
      }

    });

  }

  const resetCode = () => {
    setStep(1)
  }
  const styles = {
    container: {
      maxWidth: '300px',
      margin: '50px auto',
      padding: '20px',
      border: '1px solid #ddd',
      borderRadius: '5px',
      fontFamily: 'sans-serif',
    },
    header: {
      textAlign: 'center',
      marginBottom: '20px',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
    input: {
      padding: '7px',
      fontSize: '14px',
      borderRadius: '4px',
      border: '1px solid #ccc',
    },
    codeContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    codeDisplay: {
      flex: 1,
      fontSize: '20px',
      fontWeight: 'bold',
      backgroundColor: '#f0f0f0',
      padding: '7px',
      textAlign: 'center',
      borderRadius: '4px',
      letterSpacing: '4px',
    },
    button: {
      backgroundColor: '#00aaff',
      color: 'white',
      padding: '10px',
      fontSize: '16px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    }
  };


  const submitForgot=(event)=>{
    event.preventDefault();
    setLoading(true);
    if (typeof email !== "undefined") {
      if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/)) {
        toast.error('Email is not correct!');
        return false;
      }
    }

     var data = {
      'email': email,
    }
    API.post('/v1/oauth/forgot-password', data).then(response => {
      setLoading(false);
      console.log(response.data);
      toast.success(response.data.message)
    }).catch((error) => {
      setLoading(false);
      console.log(error);
      if (error.code == "ERR_BAD_REQUEST") {
        toast.error(error.response.data.message)
      }

    });




  }

  return (
    <>

      <section className="section-bg">
        <div className="container">
          <div className="row">
            <div className="offset-md-2 col-lg-5 col-md-7 offset-lg-4 offset-md-3">
              <div className="text-center mb-3 mt-5">

                <img src="/img/imac-logo-black.png" className="imack-logo" alt="" width={200} />

              </div>
              <div className="panel border bg-white">
                <div className="panel-heading ">
                  <h3 className="pt-4 fw-bold pb-0">{forgot? 'Forgot Password':(step == 1 ? 'Login' : 'Verify with OTP')}</h3>
                </div>
                <div className="panel-body p-3">

                  {forgot?
                <>
                  <form method="POST" onSubmit={submitForgot}>
                      <div className="form-group py-1">
                        <input name="fEmail" onChange={(e) => setEmail(e.target.value)} type="text" placeholder="Enter your Email" required className="form-control rounded-1 " />
                      </div>
                      <a href="#" id="forgot" className="fw-bold" onClick={()=>setForgot(!forgot)}>Already Have Account?</a>
                      <button type="submit" className="btn btn-primary btn-block mt-3 fw-bolder" style={{ fontSize: '15px' }}>Submit {isLoading ? (
                        <span
                          className="spinner-border spinner-border-sm ml-5"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        <span></span>
                      )}</button>
                  </form>
                </>:
                <>


                  {step == 1 ?
                    <form method="POST" onSubmit={handleSubmit} ref={formRef}>

                      <div className="form-group py-1">
                        <input name="email" onChange={(e) => setEmail(e.target.value)} type="text" placeholder="Email or mobile number" required className="form-control rounded-1 " autoComplete="username" />
                      </div>
                      <div className="form-group py-1">
                        <input name="password" onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Enter your password" required className="form-control rounded-1 " />
                      </div>
                      <div style={styles.codeContainer} className='mb-2'>
                        <input
                          type="text"
                          className='form-control'
                          placeholder="Validation Code"
                          value={inputCode}
                          onChange={(e) => setInputCode(e.target.value)}
                          onPaste={(e) => e.preventDefault()}
                          style={{ ...styles.input, flex: 2 }}
                        />
                        <div onCopy={(e) => e.preventDefault()}
                          onContextMenu={(e) => e.preventDefault()}
                          onMouseDown={(e) => e.preventDefault()}
                          unselectable="on" style={styles.codeDisplay}>{generatedCode}</div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <input type="checkbox" name="remember" id="remember" />
                          <label htmlFor="remember" className="text-muted ms-2">Remember me</label>
                        </div>
                        <a href="#" id="forgot" className="fw-bold" onClick={()=>setForgot(!forgot)}>Forgot password?</a>
                      </div>
                      <button type="submit" className="btn btn-primary btn-block mt-3 fw-bolder" style={{ fontSize: '15px' }}>Login {isLoading ? (
                        <span
                          className="spinner-border spinner-border-sm ml-5"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        <span></span>
                      )}</button>
                    </form>
                    :
                    <form onSubmit={handleSubmitOtp} ref={formRef1}>
                      <p className='text-muted '>To ensure your security,please enter the One-time Password(OTP) sent to your register mobile/email below.</p>
                      <div className="form-group d-none">

                        <input disabled onChange={(e) => setEmail(e.target.value)} name="email" type="email" className="form-control bg-light position-relative custom-email " id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" defaultValue={email} required />


                      </div>
                      <div className="form-group mt-3">

                        <input autoComplete='off' onChange={(e) => setOtp(e.target.value)} name="otp" type="text" className="form-control " id="exampleInputotp" placeholder="Enter the OTP" defaultValue="" required />


                      </div>
                      <div className="form-group text-center" style={{ fontSize: '13px' }}>
                        Didn't receive the OTP?<a href='#' onClick={() => resetCode()} className='text-blue'> Resend</a>
                      </div>

                      <button type="submit" className="btn btn-primary btn-block mt-3 fw-bolder" style={{ fontSize: '15px' }}>Submit {isLoading ? (
                        <span
                          className="spinner-border spinner-border-sm ml-5"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        <span></span>
                      )}</button>
                    </form>
                  }
                  
                </>  
                }
                </div>
              </div>
              <div className="text-center mt-3">
                Powered By © <a href="#" className="copyright-link"><img src="/img/logo.png" style={{ width: '40px' }} alt="Logo" /></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </>
  );
}